/**
 * Translations for the quiz feature area.
 * Populated by Phase 2 subagents — keep zh and en in lock-step.
 */
const quiz = {
  zh: {
    'quiz.title': '答题赚金币',
    'quiz.subtitle': '答对题目可以赚金币；奖励会从爸爸妈妈的金库发放',
    'quiz.myCoins': '我的金币',
    'quiz.submit': '提交答案',
    'quiz.next': '下一题',
    'quiz.answer.placeholder': '输入答案',

    'quiz.question.difficulty': '难度 {n}/10',
    'quiz.question.hardBonus': '难题鼓励',
    'quiz.pronunciation.label': '跟我读',
    'quiz.pronunciation.pinyin': '拼音：{value}',
    'quiz.pronunciation.ipa': '音标：{value}',
    'quiz.pronunciation.listen': '听发音',
    'quiz.pronunciation.unsupported': '这个设备暂时不能朗读',

    'quiz.hint.label': '提示：',
    'quiz.hint.askButton': '我不会，给提示',
    'quiz.hint.aiButton': 'AI 小老师',
    'quiz.hint.aiUsed': 'AI 已提示',
    'quiz.hint.aiPrefix': 'AI 小老师：',
    'quiz.hint.fallbackHard': '这题是高难度题。先别急着算答案，把题目拆成两小步：第一步找已知条件，第二步看题目真正问什么。',
    'quiz.hint.fallbackMc': '先排除最不像的选项，再把剩下的选项代回题目检查。',
    'quiz.hint.fallbackFill': '先找题目里的关键词，把空格前后的意思连起来再填写。',
    'quiz.hint.fallbackDefault': '先写下你知道的条件，再一步一步算；不确定也可以先试一个答案。',

    'quiz.feedback.streak': '连对 {streak} 题！太棒了！',
    'quiz.feedback.correct': '答对啦！',
    'quiz.feedback.wrong': '差一点点！再想想看～',

    // PR-4.2: 答对 toast — playful per-spec flavor line.
    // 金豆 is intentional here as a kid-facing flavor word.
    'quiz.reward.line': '🐹 小毛眨了眨眼，💰 +{points} 金豆',

    'quiz.error.pickOne': '选一个答案',
    'quiz.error.fillAllBlanks': '每个空格都要填',
    'quiz.error.fillAnswer': '填写答案',
    'quiz.error.generic': '出错了',

    'quiz.empty.title': '暂时没有题目',
    'quiz.empty.hint': '爸爸妈妈正在准备好题给你哦～先去玩吧！',
    'quiz.empty.goHome': '回家陪宠物',

    // v0.10.1 — temporarily give up on a hard question
    'quiz.skip.button':  '暂时放弃',
    'quiz.skip.tooltip': '这一题太难？放过它，下次和爸爸妈妈一起做',
    'quiz.skip.confirm': '这道题暂时放弃，下次和爸爸妈妈一起做？',
    'quiz.skip.acked':   '记下了',
  } as Record<string, string>,
  en: {
    'quiz.title': 'Earn coins by answering',
    'quiz.subtitle': "Correct answers earn coins from your parent's vault",
    'quiz.myCoins': 'My coins',
    'quiz.submit': 'Submit',
    'quiz.next': 'Next question',
    'quiz.answer.placeholder': 'Type your answer',

    'quiz.question.difficulty': 'Level {n}/10',
    'quiz.question.hardBonus': 'Tough-question bonus',
    'quiz.pronunciation.label': 'Read with me',
    'quiz.pronunciation.pinyin': 'Pinyin: {value}',
    'quiz.pronunciation.ipa': 'IPA: {value}',
    'quiz.pronunciation.listen': 'Listen',
    'quiz.pronunciation.unsupported': 'Speech is not available on this device',

    'quiz.hint.label': 'Hint: ',
    'quiz.hint.askButton': "I'm stuck — show a hint",
    'quiz.hint.aiButton': 'AI tutor',
    'quiz.hint.aiUsed': 'AI hint shown',
    'quiz.hint.aiPrefix': 'AI tutor: ',
    'quiz.hint.fallbackHard': "This one's tricky. Don't rush the answer — break it into two steps: first list what you know, then look at what the question is really asking.",
    'quiz.hint.fallbackMc': 'Cross out the choices that look least likely, then check the rest by plugging them back into the question.',
    'quiz.hint.fallbackFill': 'Look for the keywords in the question and connect the words around the blank.',
    'quiz.hint.fallbackDefault': "Write down what you know, then work it out step by step. Not sure? Try a guess and see.",

    'quiz.feedback.streak': '{streak} in a row! Awesome!',
    'quiz.feedback.correct': 'You got it!',
    'quiz.feedback.wrong': 'So close! Try once more~',

    // PR-4.2 mirror of the 答对 flavor line.
    'quiz.reward.line': 'Your pet blinks happily — 💰 +{points}',

    // v0.10.1 — temporarily give up
    'quiz.skip.button':  'Skip for now',
    'quiz.skip.tooltip': "Too tough? Skip it — work on it later with mom or dad",
    'quiz.skip.confirm': 'Skip this one for now and tackle it later with mom or dad?',
    'quiz.skip.acked':   'Saved for later',

    'quiz.error.pickOne': 'Pick an answer first',
    'quiz.error.fillAllBlanks': 'Fill in every blank',
    'quiz.error.fillAnswer': 'Type your answer',
    'quiz.error.generic': 'Something went wrong',

    'quiz.empty.title': 'No questions just yet',
    'quiz.empty.hint': "Mum and dad are picking good ones for you — go play for a bit!",
    'quiz.empty.goHome': 'Back to my pet',
  } as Record<string, string>,
};

export default quiz;
